/** Child route path segments for regimen sub-pages */
export const REGIMEN_ROUTE_PATHS = {
  ROOT: '/regimen',
  USER: '/user',
  MAIN_CONCERN: '/mainConcern',
  INSTRUCTIONS: 'instructions',
  EMPTY: 'empty',
  UNPAID: 'unpaid',
  PREPARATION: 'preparation',
  CONSULTATION: 'consultation',
  CHAT: 'chat',
  ADDON_INSTRUCTIONS: 'addon-instructions',
  PRODUCTS: 'products',
} as const;

/** Tab type strings emitted by toolbar-tabs component */
export const REGIMEN_TAB_TYPES = {
  REGIMEN: 'REGIMEN',
  BODY: 'BODY',
  OTHERS: 'OTHERS',
} as const;

/** Query parameter keys used in regimen routing */
export const REGIMEN_QUERY_PARAMS = {
  CLASS: 'class',
  TAB: 'tab',
  SUPPORT_TICKET_ID: 'supportTicketId',
  INIT: 'init',
  INSTRUCTIONS: 'instructions',
  FROM_HOW_TO_USE: 'fromHowToUse',
  REDIRECT_ON_BACK: 'redirectOnBack',
} as const;

/** Status bar color used by regimen shell */
export const REGIMEN_STATUS_BAR_COLOR = 'cureBlack' as const;

/**
 * Runtime values for the regimen view-state state machine. The `RegimenViewState`
 * type in regimen.types.ts is derived from this object, so this is the single
 * source of truth — add a state here and the union picks it up.
 */
export const REGIMEN_VIEW_STATES = {
  INSTRUCTION: 'regimen_instruction',
  EMPTY: 'regimen_empty',
  UNPAID: 'regimen_unpaid',
  PREPARATION: 'regimen_preparation',
  CONSULTATION: 'regimen_consultation',
  CHAT: 'regimen_chat',
  ADDON_INSTRUCTIONS: 'addon_instructions',
} as const;
